const icon00BCD4 = require('assets/images/ico-point-of-sale-additional_capabilities-00BCD4.svg')
const iconFF9800 = require('assets/images/ico-point-of-sale-additional_capabilities-FF9800.svg')
const icon9E9E9E = require('assets/images/ico-point-of-sale-additional_capabilities-9E9E9E.svg')
const iconF44336 = require('assets/images/ico-point-of-sale-additional_capabilities-F44336.svg')
const iconE91E63 = require('assets/images/ico-point-of-sale-additional_capabilities-E91E63.svg')
const icon9C27B0 = require('assets/images/ico-point-of-sale-additional_capabilities-9C27B0.svg')
const icon673AB7 = require('assets/images/ico-point-of-sale-additional_capabilities-673AB7.svg')
const icon3F51B5 = require('assets/images/ico-point-of-sale-additional_capabilities-3F51B5.svg')
const icon2196F3 = require('assets/images/ico-point-of-sale-additional_capabilities-2196F3.svg')
const icon03A9F4 = require('assets/images/ico-point-of-sale-additional_capabilities-03A9F4.svg')
const iconCDDC39 = require('assets/images/ico-point-of-sale-additional_capabilities-CDDC39.svg')
const icon009688 = require('assets/images/ico-point-of-sale-additional_capabilities-009688.svg')
const icon4CAF50 = require('assets/images/ico-point-of-sale-additional_capabilities-4CAF50.svg')
const icon8BC34A = require('assets/images/ico-point-of-sale-additional_capabilities-8BC34A.svg')
const iconFFEB3B = require('assets/images/ico-point-of-sale-additional_capabilities-FFEB3B.svg')
const iconFFC107 = require('assets/images/ico-point-of-sale-additional_capabilities-FFC107.svg')
const iconFF5722 = require('assets/images/ico-point-of-sale-additional_capabilities-FF5722.svg')
const icon795548 = require('assets/images/ico-point-of-sale-additional_capabilities-795548.svg')
const icon607D8B = require('assets/images/ico-point-of-sale-additional_capabilities-607D8B.svg')

const BASE = [
  {color: '9E9E9E'},
  {color: 'F44336'},
  {color: 'E91E63'},
  {color: '9C27B0'},
  {color: '673AB7'},
  {color: '3F51B5'},
  {color: '2196F3'},
  {color: '03A9F4'},
  {color: '00BCD4'},
  {color: '009688'},
  {color: '4CAF50'},
  {color: '8BC34A'},
  {color: 'CDDC39'},
  {color: 'FFEB3B'},
  {color: 'FFC107'},
  {color: 'FF9800'},
  {color: 'FF5722'},
  {color: '795548'},
  {colorMaximo: '607D8B'}
]

/*
  id
  code => capacity code,
  description => capacity description

  code > 0, have capicity
  transform BASE to {color, id, description}
*/
const findIconColor = (id, code, description, enrollment) => {
  if(code > 0 || enrollment.toString() === '3') {
    let index_cap_id = BASE.findIndex(item => item.id == id)

    // the id have a specific color
    if (index_cap_id >= 0){ return BASE[index_cap_id].color }

    // Find next index with description null && find index with similar description
    let index_desc_null = BASE.findIndex(item => item.description == null)
    let index_desc_cap = BASE.findIndex(item => item.description == description)

    if (index_desc_null > 0 && index_desc_cap < 0){
      // color without description && I can't find the description
      BASE[index_desc_null].id = id
      BASE[index_desc_null].description = description

      return BASE[index_desc_null].color
    } else if (index_desc_cap >= 0) {
      // Find the description
      return BASE[index_desc_cap].color
    } else if (index_desc_null > 18 && index_desc_cap < 0 ) {
      // description not null and no can't find
      return '00BCD4'
    } else {
      BASE[index_desc_null].id = id
      BASE[index_desc_null].description = description
      return BASE[index_desc_null].color
    }
  } else {
    // Default color
    return '00BCD4'
  }
}

export {
  icon00BCD4,
  iconFF9800,
  icon9E9E9E,
  iconF44336,
  iconE91E63,
  icon9C27B0,
  icon673AB7,
  icon3F51B5,
  icon2196F3,
  icon03A9F4,
  iconCDDC39,
  icon009688,
  icon4CAF50,
  icon8BC34A,
  iconFFEB3B,
  iconFFC107,
  iconFF5722,
  icon795548,
  icon607D8B,
  findIconColor
}
